import * as analytics from '@anm/analytic';
import FormHelperText from '@anm/components/form/FormHelperText';
import * as intercom from '@anm/helpers/intercom';
import useSwitchState from '@anm/hooks/useSwitchState';
import { noop } from 'lodash/fp';
import { useCallback, FC } from 'react';

import { ButtonLink, DowngradeButtons } from '../../Wrapper';

import ConfirmCheckbox from './ConfirmCheckbox';
import Wrapper, { Bold, ButtonWrapper, FlexRight, InfoContainer, P, SupportButton, TitleBlockWrapper } from './Wrapper';

export type StarterStepProps = {
  planName: string;
  isCancelPending: boolean;
  isKeepPending: boolean;
  onKeep: () => void;
  onCancel: () => void;
  onStarter: () => void;
  error?: string;
};

const StarterStep: FC<StarterStepProps> = ({
  planName,
  error,
  isKeepPending,
  isCancelPending,
  onKeep,
  onStarter,
  onCancel
}) => {
  const [isConfirmed, _, __, toggleConformed] = useSwitchState();
  const handleSwitchToStarter = useCallback(() => {
    analytics.trackCancelSwitchToStarter();
    onStarter();
  }, [onKeep]);

  const isStarter = planName.toLowerCase().includes('starter');

  return (
    <Wrapper>
      <TitleBlockWrapper
        direction="center"
        size="medium"
        title="We are sorry to see you go"
        description="Please confirm the cancellation of your subscription"
      />
      <InfoContainer>
        <Bold size="14">More options for you:</Bold>
        <ul>
          {!isStarter && (
            <li>
              Switch to Starter plan ($9/month). It is similar to Creator, but max video export is 10 min.
            </li>
          )}
          <li>Keep your subscription</li>
          <li>
            <SupportButton size="big" variant="link" onClick={intercom.openChat}>
              Talk to support
            </SupportButton>
          </li>
        </ul>
      </InfoContainer>

      <P>
        <Bold size="16">Lose benefits </Bold>
        <br />
        Once you cancel your plan, you will lose access to all Wave.video paid features at the end of your current
        billing period.
      </P>

      <ConfirmCheckbox
        checked={isConfirmed}
        onClick={toggleConformed}
        title={`I confirm and agree to allow my plan to default to the free account limitations.`}
      />
      {error && <FormHelperText variant="static">{error}</FormHelperText>}

      <DowngradeButtons>
        <ButtonWrapper size="big" variant="light-blue" onClick={onKeep}>
          Yes, keep my plan
        </ButtonWrapper>
        {!isStarter && (
          <ButtonWrapper isPending={isKeepPending} size="big" variant="light-blue" onClick={handleSwitchToStarter}>
            Get Starter for only $9/month
          </ButtonWrapper>
        )}
        <FlexRight>
          <ButtonLink
            color="blue"
            size="big"
            active={isConfirmed}
            variant="blue-link"
            isPending={isCancelPending}
            onClick={isConfirmed ? onCancel : noop}
          >
            No, confirm cancellation
          </ButtonLink>
        </FlexRight>
      </DowngradeButtons>
    </Wrapper>
  );
};
export default StarterStep;
